import React from "react";
import { Container, Typography } from "@mui/material";

const NotFound = () => {
  return (
    <Container
      maxWidth="sm"
      style={{ textAlign: "center", marginTop: "50px" }}
    >
      <Typography variant="h4" color="error" gutterBottom>
        404 - Página Não Encontrada
      </Typography>
      <Typography variant="body1">
        A página que você está tentando acessar não existe.
      </Typography>
    </Container>
  );
};

export default NotFound;
